import React, { memo } from "react";
import PropTypes from "prop-types";
import { Switch } from "react-router-dom";
import PropsRoute from "../../shared/components/PropsRoute";
import Home from "./home/Home";
import Blog from "./blog/Blog";
import BlogPost from "./blog/BlogPost";
import Diamonds from "./diamonds/Diamonds";
import DiamondDetails from "./diamonds/DiamondDetails";
import Diamond360 from "./diamonds/DiamondDetails/Standalone360Player";
import All from "./diamonds/All";
import Fav from "./diamonds/Fav";
import Compare from "./diamonds/Compare";
import Bag from "./diamonds/Bag";
import Jewellery from "./jewellery/Jewellery";
import TermsAndConditions from "./termsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./termsAndConditions/PrivacyPolicy";
import FAQs from "./termsAndConditions/FAQs";
import AboutUs from "./aboutUs/AboutUs";
import ContactUs from "./contactUs/ContactUs";
import ApiPage from "./api/ApiPage";
import { cdnURL } from './../../shared/functions/api/';

function Routing(props) {
  const {
    blogPosts, 
    selectBlog, 
    selectHome, 
    headSectionAnimationComplete,
    selectDiamonds,
    jewelleryList, selectJewellery, selectTAndCs, selectPrivacyPolicy, selectFAQs, selectBlogPost, selectAboutUs, selectContactUs, selectApiPage,
    selectDiamondDetails,
    selectAll,
    selectFav,
    selectCompare,
    selectBag,
    onHomeSectionsScroll,
    openLoginDialog,
    openPasswordDialog,
    openMessageDialog,
    closeDialog,
    openEmailDialog,
    pushMessageToSnackbar,
    openRegisterDialog,
  } = props;
  return (
    <Switch>
      {blogPosts.map((post, index) => (
        <PropsRoute
          /* We cannot use the url here as it contains the get params */
          path={post.url}
          component={BlogPost}
          title={post.title}
          key={post.title}
          src={cdnURL + post.src}
          date={post.date}
          content={post.content}
          allPosts={blogPosts}
          selectBlogPost={selectBlogPost}
          post={post}
          index={index}
        />
      ))}
      <PropsRoute
        exact
        path="/news"
        component={Blog}
        selectBlog={selectBlog}
        blogPosts={blogPosts}
      />
      <PropsRoute
        exact
        path="/diamonds/test"
        component={Diamonds}
        selectDiamonds={selectDiamonds}
      />
      <PropsRoute
        path="/diamonds/all/:page?"
        component={All}
        selectAll={selectAll}
        openEmailDialog={openEmailDialog}
      />
      <PropsRoute
        path="/labgrowndiamonds"
        component={() => document.location.href = '/diamonds/all/lab-grown'}
      />
      <PropsRoute
        exact
        path="/diamonds/:diamondId/360"
        component={Diamond360}
      />
      <PropsRoute
        exact
        path="/diamonds/:diamondId/:page"
        component={DiamondDetails}
        selectDiamondDetails={selectDiamondDetails}
        pushMessageToSnackbar={pushMessageToSnackbar}
        openEmailDialog={openEmailDialog}
      />
      <PropsRoute
        exact
        path="/diamonds/fav"
        component={Fav}
        selectFav={selectFav}
      />
      <PropsRoute
        exact
        path="/diamonds/compare"
        component={Compare}
        selectCompare={selectCompare}
        openEmailDialog={openEmailDialog}
      />
      <PropsRoute
        exact
        path="/diamonds/bag"
        component={Bag}
        selectBag={selectBag}
      />
      <PropsRoute
        exact
        path="/jewellery"
        component={Jewellery}
        selectJewellery={selectJewellery}
        jewelleryList={jewelleryList}
      />
      <PropsRoute
        exact
        path="/terms-and-conditions"
        component={TermsAndConditions}
        selectTAndCs={selectTAndCs}
      />
      <PropsRoute
        exact
        path="/privacy-policy"
        component={PrivacyPolicy}
        selectPrivacyPolicy={selectPrivacyPolicy}
      />
      <PropsRoute
        exact
        path="/faqs"
        component={FAQs}
        selectFAQs={selectFAQs}
      />
      <PropsRoute
        exact
        path="/about-us"
        component={AboutUs}
        selectAboutUs={selectAboutUs}
        openLoginDialog={openLoginDialog}
        openPasswordDialog={openPasswordDialog}
      />
      <PropsRoute
        exact
        path="/contact-us"
        component={ContactUs}
        selectContactUs={selectContactUs}
        pushMessageToSnackbar={pushMessageToSnackbar}
      />
      <PropsRoute
        exact
        path="/api"
        component={ApiPage}
        selectApiPage={selectApiPage}
        openEmailDialog={openEmailDialog}
        pushMessageToSnackbar={pushMessageToSnackbar}
        openRegisterDialog={openRegisterDialog}
      />
      )
      <PropsRoute
        path="/:page?/:token?"
        component={Home}
        openLoginDialog={openLoginDialog}
        openPasswordDialog={openPasswordDialog}
        openMessageDialog={openMessageDialog}
        closeDialog={closeDialog}
        selectHome={selectHome}
        headSectionAnimationComplete={headSectionAnimationComplete}
        onSectionsScroll={onHomeSectionsScroll}
        blogPosts={blogPosts}
        openEmailDialog={openEmailDialog}
        pushMessageToSnackbar={pushMessageToSnackbar}
        openRegisterDialog={openRegisterDialog}
      />)
    </Switch>
  );
}

export default memo(Routing);
